"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OktonGridHeader = void 0;
const react_1 = require("@chakra-ui/react");
const react_2 = __importDefault(require("react"));
const lu_1 = require("react-icons/lu");
function OktonGridHeader({ columns, sort, onSort, actions, fontSize, textTransform, fontWeight = 'medium', }) {
    const subtleBg = (0, react_1.useColorModeValue)('gray.50', 'gray.700');
    const activeColor = (0, react_1.useColorModeValue)('blue.600', 'blue.300');
    return (react_2.default.createElement(react_1.Box, { as: "thead" },
        react_2.default.createElement(react_1.Box, { as: "tr", borderBottomWidth: "1px", bg: subtleBg, fontSize: fontSize, textTransform: textTransform },
            columns.map(column => {
                var _a, _b;
                const sortable = Boolean(column.value);
                const active = (sort === null || sort === void 0 ? void 0 : sort.key) === column.key;
                const alignment = (_a = column.align) !== null && _a !== void 0 ? _a : 'left';
                return (react_2.default.createElement(react_1.Box, { key: column.key, as: "th", textAlign: alignment, px: (_b = column.px) !== null && _b !== void 0 ? _b : '5', py: "3", w: column.width, display: column.display, color: active ? activeColor : 'gray.500', fontWeight: fontWeight, cursor: sortable ? 'pointer' : 'default', userSelect: "none", _hover: sortable ? { color: activeColor } : undefined, onClick: () => sortable && onSort(column.key), title: sortable ? 'Ordenar por esta coluna' : undefined },
                    react_2.default.createElement(react_1.Flex, { align: "center", gap: "1", justify: alignment === 'right'
                            ? 'flex-end'
                            : alignment === 'center'
                                ? 'center'
                                : 'flex-start' },
                        column.title,
                        sortable && !active
                            ? (react_2.default.createElement(react_1.Box, { as: "span", opacity: 0.35 }, react_2.default.createElement(lu_1.LuChevronsUpDown, {
                                size: 13,
                            })))
                            : null,
                        sortable && active && (sort === null || sort === void 0 ? void 0 : sort.desc)
                            ? react_2.default.createElement(lu_1.LuArrowDown, {
                                size: 13,
                            })
                            : null,
                        sortable && active && !(sort === null || sort === void 0 ? void 0 : sort.desc)
                            ? react_2.default.createElement(lu_1.LuArrowUp, {
                                size: 13,
                            })
                            : null)));
            }),
            actions ? react_2.default.createElement(react_1.Box, { as: "th", px: "3", py: "3" }) : null)));
}
exports.OktonGridHeader = OktonGridHeader;
//# sourceMappingURL=GridHeader.js.map